import { IconButton } from '@mui/material'
import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const BackIcon = ({ to = -1 }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (typeof to === 'number') {
            navigate(to);
        } else {
            navigate(to);
        }
    };

    return (
        <IconButton onClick={handleClick}>
            <ArrowBackIcon sx={{ color: "#C86337", fontSize: 30 }} />
        </IconButton>
    );
}

export default BackIcon;

//both work same here use to Link tag
// const BackIcon = ({ to = - 1 }) => {
//     return (
//         <Link to={to}>
//             <IconButton>
//                 <ArrowBackIcon sx={{ color: "#C86337", fontSize: 30 }} />
//             </IconButton>
//         </Link>
//     )
// }

// export default BackIcon